import styled, { keyframes } from 'styled-components'

const iconBouncingAnimation = keyframes`
  0%, 99% {
    transform: scale(0);
  }
  12.5%, 87.5% {
    transform: scale(.25);
  }
  25%, 75% {
    transform: scale(.5);
  }
  37.5%, 62.5% {
    transform: scale(.75);
  }
  50% {
    transform: scale(1);
  }
`

export const AiSparkleIcon = styled.div`
  height: 1rem;
  position: relative;
  width: 1rem;

  &:before,
  &:after {
    animation: ${iconBouncingAnimation} 1.8s ease-in-out infinite;
    background: center no-repeat;
    background-size: contain;
    content: '';
    position: absolute;
    transform: scale(0);
    transform-origin: center;
  }

  &:after {
    background-image: url('https://static.rfstat.com/renderforest/images/v2/new-homepage/header/ai-icon-1.svg');
    height: 12px;
    right: 0;
    top: 0;
    width: 11px;
  }

  &:before {
    animation-delay: 0.4s;
    background-image: url('https://static.rfstat.com/renderforest/images/v2/new-homepage/header/ai-icon-2.svg');
    height: 11px;
    bottom: 0;
    left: 0;
    width: 10px;
  }
`
